<template>
  <div class="header">
    <div class="personal-head">
      <i class="el-icon-arrow-left" @click="handelBack" />
      {{ title }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeaderBack',
  props: {
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    /** @desc 返回上一层 **/
    handelBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 768px) {
  .header {
    position: sticky;
    top: 0;
  }
  .personal-head {
    height: rem(88);
    background: #ffffff;
    font-family: 'Aspira Medium';
    font-size: rem(36);
    color: #000000;
    text-align: center;
    font-weight: 500;
    line-height: rem(88);
    position: relative;
    i {
      font-size: rem(48);
      position: absolute;
      left: rem(28);
      top: rem(20);
    }
  }
}
</style>